import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer class="main-footer">
            <strong>Copyright &copy; 2016-2017 <a href="https://webideainfotech.in/">Webideainfotech</a>.</strong> All rights reserved.
         </footer>
);

export default Footer;
